import { ApiFactoryClients } from "../api.types";

export interface BillingUsage {
  removal_used_this_month: number;
  removal_cap_monthly: number;
  removal_remaining: number;
  month_reset_at: string;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  getUsage: (): Promise<BillingUsage> =>
    codeHttpClient
      .get("/account/billing/usage")
      .then(({ data }) => data as BillingUsage),
});
